function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEkcBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1520 601",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-312.021)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.285,82.44C112.285,86.647 87.642,90.056 57.244,90.056C26.846,90.056 2.204,86.647 2.204,82.44L2.204,112.135C2.204,116.341 26.846,119.752 57.244,119.752C87.642,119.752 112.285,116.341 112.285,112.135L112.285,82.44Z",
    style: {
      fill: "rgb(213,224,77)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.285,132.064C112.285,136.27 87.642,139.68 57.244,139.68C26.846,139.68 2.204,136.27 2.204,132.064L2.204,161.759C2.204,165.965 26.846,169.376 57.244,169.376C87.642,169.376 112.285,165.965 112.285,161.759L112.285,132.064Z",
    style: {
      fill: "rgb(84,185,71)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.285,181.688C112.285,185.894 87.642,189.304 57.244,189.304C26.846,189.304 2.204,185.894 2.204,181.688L2.204,211.383C2.204,215.589 26.846,219 57.244,219C87.642,219 112.285,215.589 112.285,211.383L112.285,181.688Z",
    style: {
      fill: "rgb(0,125,183)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.087,138.908L33.087,118.979C14.981,117.754 2.465,115.193 2.22,112.223L2.22,132.152C2.465,135.122 14.981,137.682 33.087,138.908Z",
    style: {
      fill: "rgb(160,206,103)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.087,188.532L33.087,168.603C14.981,167.378 2.465,164.817 2.22,161.847L2.22,181.776C2.465,184.746 14.981,187.306 33.087,188.532Z",
    style: {
      fill: "rgb(0,160,176)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,82.892L0,82.917C0,82.908 0.004,82.9 0.004,82.892L0,82.892Z",
    style: {
      fill: "rgb(35,31,32)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.285,82.501C112.285,86.707 87.642,90.118 57.244,90.118C26.846,90.118 2.204,86.707 2.204,82.501C2.204,78.295 26.846,74.885 57.244,74.885C87.642,74.885 112.285,78.295 112.285,82.501Z",
    style: {
      fill: "rgb(0,82,136)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.414,160.664L169.14,160.664L169.14,211.878L138.263,211.878L138.263,82.455L169.14,82.455L169.14,132.838L177.691,132.838L214.853,82.455L252.848,82.455L202.651,145.594L257.008,211.878L218.182,211.878L177.414,160.664Z",
    style: {
      fill: "rgb(0,82,136)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.16667,0,0,4.16667,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.575,169.856C337.265,179.473 327.119,184.699 314.885,184.699C295.748,184.699 279.201,171.202 279.201,147.166C279.201,124.979 294.362,109.633 314.792,109.633C326.531,109.633 336.143,114.313 342.883,122.865L362.557,98.119C350.62,86.57 333.699,80.052 315.161,80.052C275.226,80.052 247.029,107.97 247.029,147.166C247.029,186.363 275.226,214.281 315.161,214.281C335.615,214.281 352.599,206.778 364.562,194.226L344.575,169.856Z",
    style: {
      fill: "rgb(0,82,136)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEkcBlue);
export default __webpack_public_path__ + "static/media/EKC_blue.f5dace10984e7073d129a6b69f3ddceb.svg";
export { ForwardRef as ReactComponent };